import * as Sentry from '@sentry/react';
import { useParams } from 'react-router-dom';
import { LoadingOverlay, Stack, Title } from 'ui';

import { StudentUnpaidFeesList } from '../components/organisms/lists/StudentUnpaidFeesList/StudentUnpaidFeesList';

const StudentUnpaidFeesListGuard = () => {
  const { studentId } = useParams();

  if (!studentId) {
    return <LoadingOverlay visible />;
  }
  return <StudentUnpaidFeesList studentId={studentId} />;
};

const UnpaidFees = () => {
  return (
    <Sentry.ErrorBoundary fallback={<p>There was an error loading your unpaid fees</p>}>
      <Stack>
        <Title order={2}>Unpaid Fees</Title>
        <StudentUnpaidFeesListGuard />
      </Stack>
    </Sentry.ErrorBoundary>
  );
};

export { UnpaidFees };
